
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/feedback/events-survey/[slug]",
      function () {
        return require("private-next-pages/feedback/events-survey/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/feedback/events-survey/[slug]"])
      });
    }
  